export default StyleSheet.create({
  title: {
    fontSize: 24
  },

})
